import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { Icon } from 'react-fa';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { asyncSendMail } from '../../redux/modules/contat-us';
import { email, maxLength, minLength, required } from '../../utils/validators';

const renderField = ({ input, placeholder, type, meta: { touched, error } }) => {
  return (
    <div className="field">
      <input {...input} className="form-control" placeholder={placeholder} type={type}/>
      {touched && error && <Icon name="exclamation"/>}
    </div>
  );
};

const renderTextAreaField = ({ input, placeholder, rows, meta: { touched, error } }) => (
  <div className="field">
    <textarea  {...input} className="form-control" placeholder={placeholder} rows={rows}/>
    {touched && error && <Icon name="exclamation"/>}
  </div>
);

class ContactForm extends PureComponent {

  handlerSendMail(info) {
    const { asyncSendMail, reset } = this.props;
    return asyncSendMail(info).then(() => {
      reset();
    });
  }

  render() {
    const { fetching, pristine, submitting, handleSubmit, serverError } = this.props;
    return (
      <div className="row contact-us-form">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit(this.handlerSendMail.bind(this))}>
            <div className="row">
              <div className="col-md-4 col-md-4">
                <div className="form-group">
                  <Field
                    disabled={submitting}
                    type="text"
                    placeholder="O seu nome"
                    name="name"
                    validate={[required]}
                    component={renderField}/>
                </div>
                <div className="form-group">
                  <Field
                    validate={[required, email]}
                    disabled={submitting}
                    type="email"
                    placeholder="O seu email"
                    name="email"
                    component={renderField}/>
                </div>
                <div className="form-group">
                  <Field
                    disabled={submitting}
                    validate={[minLength(9), maxLength(20)]}
                    type="text"
                    placeholder="O seu contacto telefonico"
                    name="phone"
                    component={renderField}/>
                </div>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <Field
                    disabled={submitting}
                    validate={[required, minLength(10), maxLength(200)]}
                    rows="6"
                    className="form-control"
                    placeholder="A sua mensagem"
                    name="message"
                    component={renderTextAreaField}/>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="col-lg-12 text-right form-buttons">
                {serverError && <label className="pull-left">Ocorreu um erro. Por favor tente novamente.</label>}
                <Button disabled={pristine} loading={fetching} type="submit" className="btn btn-xl">Enviar</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

ContactForm = reduxForm({
  form: 'contactUs'
})(ContactForm);

export default connect(
  (state) => {
    return ({
      fetching: state.contactsUs.fetching,
      serverError: state.contactsUs.error
    });
  },
  (dispatch) => {
    return bindActionCreators({ asyncSendMail }, dispatch);
  }
)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js